import React from "react";
import { SimpleShowLayout, TextField, NumberInput } from "react-admin";

const Tab = (props) => {
  function s(p) {
    return props.side + "." + p;
  }
  return (
    <SimpleShowLayout {...props}>
      <TextField source={s("season.team.name")} />
      <TextField source={s("id")} />
      <TextField source={s("baseball.id")} />
      <NumberInput source={s("baseball.runs")} />
      <NumberInput source={s("baseball.hits")} />
      <NumberInput source={s("baseball.errors")} />
    </SimpleShowLayout>
  );
};

export default Tab;
